export const RED_TESTING_CONFIG = {
  experiments: [
    {
      id: 'assinatura-inativa',
      variants: [
        {
          weight: 0.5
        }
      ]
    }
  ]
}
